<template>
  <a @click="sortby">
    <slot />
    {{ ' ' }}
    <span v-if="modelValue == field && !reverse">▾</span>
    <span v-if="modelValue == field && reverse">▴</span>
  </a>
</template>

<script lang="ts" setup generic="T extends string">
const props = defineProps<{
  modelValue: T;
  field: T;
  reverse: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: T): void
  (e: 'update:reverse', event: boolean): void
}>();

function sortby() {
  if (props.modelValue === props.field) {
    emit('update:reverse', !props.reverse);
  } else {
    emit('update:modelValue', props.field);
    if (props.reverse) {
      emit('update:reverse', false);
    }
  }
}
</script>
